import { initSideMenu } from "./components/side-menu";

initSideMenu()